var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import * as Util from '../util';
import ZonaImg from './zona-img';
import ZonaSvg from './zona-svg';
import ImagenPagina from './imagen-pagina';

var esZonaImg = function esZonaImg(zona) {
  return zona.boton.startsWith('img');
};

var esZonaSvg = function esZonaSvg(zona) {
  return !esZonaImg(zona) && zona.activa !== 'no';
};

var porCiento = function porCiento(cad) {
  return cad + '%';
};
/** 
 * Representa cada página de un libro.
 * 
 * Requiere que existan los siguientes recursos en la carpeta: "``contenido/``"
 * 
 *  - "``{libroId}.png``" __Imagen por defecto__. Ejemplo: ``SB.png``
 *  - "``{libroId}{pad3(numPagina)}.jpg``" __Imagen de baja resolución__. Ejemplo: ``SB001.jpg``
 *  - "``{libroId}{pad3(numPagina)}.png``" __Imagen de alta resolucion__. Ejemplo: ``SB001.png``
 * 
 * Inicialmente, el componente muestra la animación de precarga mientras se carga 
 * la imagen por defecto. Despues lanza la carga de la imagen de baja resolución 
 * que si existe, una vez cargada sustituira a la imagen por defecto.
 * 
 * La imagen de alta resolución solo se carga a efectos de cache del nevegador, 
 * pero no se muestra.
 * 
 * Para que funcione correctamente, debe estar enmarcada en un al menos en dos contenedores:
 * 
 * Para una página:
 * ```html
 * <div className='contenedor libro1'>
 *     <div className='marcoPaginas unaPagina'>
 *         <Pagina ...props/>
 *     </div>
 * </div>    
 * ```
 * 
 * Para dos páginas:
 * ```html
 * <div className='contenedor libro1'>
 *     <div className='marcoPaginas dosPagina'>
 *         <Pagina id='imagenPaginaIzquierda' ...props/>
 *         <Pagina id='imagenPaginaDerecha' ...props/>
 *     </div>
 * </div>    
 * ```
 */


var Pagina = (_temp2 = _class = function (_Component) {
  _inherits(Pagina, _Component);

  function Pagina() {
    var _temp, _this, _ret;

    _classCallCheck(this, Pagina);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.keyParaZona = function (indexZona) {
      var _this$props = _this.props,
          libroId = _this$props.libroId,
          numPagina = _this$props.numPagina;
      return 'zona-' + libroId + '-' + numPagina + '-' + indexZona;
    }, _this.renderZonaImg = function (zona, index) {
      var _this$props2 = _this.props,
          libroId = _this$props2.libroId,
          numPagina = _this$props2.numPagina,
          onZona = _this$props2.onZona;

      var propiedades = _this.calcularPropiedadesZonaImg(zona);

      return React.createElement(ZonaImg, _extends({
        key: _this.keyParaZona(index),
        zona: zona
      }, propiedades, {
        onClick: function onClick() {
          return onZona(libroId, numPagina, zona.numZona);
        }
      }));
    }, _this.renderZonaSvg = function (zona, index) {
      var _this$props3 = _this.props,
          libroId = _this$props3.libroId,
          numPagina = _this$props3.numPagina,
          onZona = _this$props3.onZona,
          multiplicadorBaja = _this$props3.multiplicadorBaja;
      return React.createElement(ZonaSvg, {
        key: _this.keyParaZona(index),
        zona: zona,
        multiplicadorBaja: multiplicadorBaja,
        onClick: function onClick() {
          return onZona(libroId, numPagina, zona.numZona);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Calcula el tamaño del recurso teniendo en cuenta que:
   *  - El alto del recurso se deja proporcional al alto de la página.
   *  - Se calcula el ancho del recurso de forma que mantenga su aspect ratio.
   *  - Los valores finales de left, top, width y height, están expresados
   *    en coordenadas proporcionales (%) al tamaño de la página.
   */


  Pagina.prototype.calcularPropiedadesZonaImg = function calcularPropiedadesZonaImg(zona) {
    var _props = this.props,
        multiplicadorBaja = _props.multiplicadorBaja,
        dimensionesBaja = _props.dimensionesBaja,
        configBotones = _props.configBotones;

    var _zona$boton$split = zona.boton.split(','),
        numRecurso = _zona$boton$split[1],
        textoExtra = _zona$boton$split[2],
        x = _zona$boton$split[3],
        y = _zona$boton$split[4];

    var recursoId = 'img' + numRecurso;
    var recurso = configBotones[recursoId];
    var ratioBoton = recurso.w / recurso.h;
    var ratioPagina = dimensionesBaja.w / dimensionesBaja.h;
    var left = 100 * (Number(x) / multiplicadorBaja) / dimensionesBaja.w;
    var top = 100 * (Number(y) / multiplicadorBaja) / dimensionesBaja.h;
    var height = 100 * (recurso.h / multiplicadorBaja) / dimensionesBaja.h;
    var width = height * ratioBoton / ratioPagina;
    return {
      clase: recurso.clase,
      textoFijo: recurso.texto,
      textoExtra: textoExtra,
      left: porCiento(left),
      top: porCiento(top),
      width: porCiento(width),
      height: porCiento(height)
    };
  };

  Pagina.prototype.getZonaId = function getZonaId(index) {
    var _props2 = this.props,
        libroId = _props2.libroId,
        numPagina = _props2.numPagina;
    return libroId + Util.pad3(numPagina) + '.' + (index + 1);
  };

  Pagina.prototype.getZonasAsociadas = function getZonasAsociadas(asociarZona) {
    var _this2 = this;

    if (!asociarZona) {
      return false;
    }

    var libroId = this.props.libroId;
    var zonasAsocidas = asociarZona.split(':');
    return zonasAsocidas.map(function (zonaAsocidada) {
      var _ref = zonaAsocidada.indexOf(',') !== -1 ? zonaAsocidada.split(',').map(Number) : [_this2.props.numPagina, Number(zonaAsocidada)],
          numPagina = _ref[0],
          numZona = _ref[1];

      return libroId + Util.pad3(Number(numPagina)) + '_' + numZona;
    });
  };

  Pagina.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        id = _props3.id,
        libroId = _props3.libroId,
        numPagina = _props3.numPagina,
        zonas = _props3.zonas,
        dimensionesBaja = _props3.dimensionesBaja,
        children = _props3.children;
    var viewBox = [0, 0, dimensionesBaja.w, dimensionesBaja.h].join(' ');
    var zonasIdentificadas = zonas.map(function (zona, index) {
      return _extends({}, zona, {
        id: _this3.getZonaId(index),
        zonasAsociadas: _this3.getZonasAsociadas(zona.asociarZona)
      });
    });
    var zonasSvg = zonasIdentificadas.filter(esZonaSvg).map(this.renderZonaSvg);
    var zonasImg = zonasIdentificadas.filter(esZonaImg).map(this.renderZonaImg);
    return React.createElement('div', {
      className: 'cajaPagina pagina' + libroId + Util.pad3(numPagina),
      ref: function ref(root) {
        return _this3.root = root;
      }
    }, React.createElement(ImagenPagina, {
      id: id,
      libroId: libroId,
      numPagina: numPagina
    }), React.createElement('svg', {
      viewBox: viewBox,
      className: 'zonas'
    }, zonasSvg), zonasImg, children);
  };

  return Pagina;
}(Component), _class.defaultProps = {
  id: 'imagenPaginaIzquierda',
  libroId: '',
  numPagina: 1,
  dimensionesBaja: {
    w: 1000,
    h: 1250
  },
  multiplicadorBaja: 0.711111111111,
  zonas: [],
  configBotones: {}
}, _temp2);
Pagina.propTypes = process.env.NODE_ENV !== "production" ? {
  /** id de la página */
  id: t.string.isRequired,

  /** Identificador del libro, ejemplo: 'SB' */
  libroId: t.string.isRequired,

  /** número de página */
  numPagina: t.number.isRequired,

  /** array con las zonas de la página */
  zonas: t.array.isRequired,

  /** dimensiones de la página en baja resolución */
  dimensionesBaja: t.shape({
    w: t.number.isRequired,
    h: t.number.isRequired
  }).isRequired,

  /** factor de conversion de coordenadas zona => coordenadas baja */
  multiplicadorBaja: t.number.isRequired,

  /** configuración de los recursos para las zonas tipo IMG */
  configBotones: t.object.isRequired,

  /** función que se llama al pinchar en una zona: 'onClickZona(libroId, numPagina, numZona)' */
  onZona: t.func,
  children: t.any
} : {};
export default Pagina;